import { render, staticRenderFns } from "./_reportDbSnapshotsTable.vue?vue&type=template&id=b0c7ffc6"
import script from "./_reportDbSnapshotsTable.vue?vue&type=script&lang=js"
export * from "./_reportDbSnapshotsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports